import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';
import type { Color, Hours, Trend } from '../types.tsx';

export const comparePeriodStatistics = (currentDuration: Hours, priorDuration: Hours): Trend => {
	if (currentDuration > priorDuration) {
		return 'over';
	}
	if (currentDuration < priorDuration) {
		return 'under';
	}

	return 'equal';
};

type TrendColors = {
	backgroundColor: Color;
};
export const getTrendBackgroundColor = (trend: Trend): TrendColors => {
	switch (trend) {
		case 'under':
		case 'equal':
			return {
				backgroundColor: token('color.icon.success', colors.G300),
			};
		case 'over':
			return {
				backgroundColor: token('color.icon.warning', colors.Y500),
			};
		default:
			// prettier-ignore
			// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
			(trend as never);
			throw new Error('Unknown trend is given to getTrendBackgroundColor');
	}
};
